import { FC, useEffect } from 'react';
import { useAnalytics } from '@cld/analytics';
import { SideMenuMobile, SideMenuProps } from '../../components/SideMenu';
import { ApplicationsDropdownInlineTriggerMobile } from '../DefaultApplicationsDropdown';
import { useSideMenu } from '../../components/SideMenu/SideMenu.context';

export const DefaultSideMenuMobile: FC<SideMenuProps> = ({ children, header, footer }) => {
  const { isSideMenuMobileOpen } = useSideMenu();
  const analytics = useAnalytics('side-menu mobile');

  useEffect(() => {
    analytics(`${isSideMenuMobileOpen ? 'expand' : 'collapse'} side menu mobile`, `${isSideMenuMobileOpen ? 'show' : 'hide'}`);
  }, [isSideMenuMobileOpen, analytics]);

  return (
    <SideMenuMobile header={header === undefined ? <ApplicationsDropdownInlineTriggerMobile /> : header} footer={footer}>
      {children}
    </SideMenuMobile>
  );
};
